<template>
    <div class="csps-container" v-if="cspCodes.length === 0 && conventionCspConfig.allIncluded">
        <typo name="body-14-normal"> Toutes les catégories concernées </typo>
    </div>
    <div
        class="csps-container"
        v-else-if="cspCodes.length === 0 && !conventionCspConfig.allIncluded"
    >
        <div v-for="csp in conventionCspConfig.availableCodes" :key="csp._uid">
            <div :class="`csp-item ${csp.toLowerCase()}`">
                <typo name="body-14-normal">
                    {{ getCspLabel(csp) }}
                </typo>
            </div>
        </div>
    </div>
    <div v-else class="csps-container">
        <div v-for="csp in cspCodes" :key="csp._uid">
            <div :class="`csp-item ${csp.toLowerCase()}`">
                <typo name="body-14-normal">
                    {{ getCspLabel(csp) }}
                </typo>
            </div>
        </div>
    </div>
</template>

<script>
import { find, includes, get } from "lodash";

export default {
    components: {},
    props: ["cspCodes", "conventionCspConfig"],
    computed: {
        cspConfig() {
            return this.$privateDico.convention.csps;
        },
    },
    methods: {
        getCspLabel(csp) {
            const cspKey = find(Object.keys(this.cspConfig), key =>
                includes(key, csp.toLowerCase())
            );
            return get(this.cspConfig, `${cspKey}.label`, "").toLowerCase();
        },
    },
};
</script>

<style scoped lang="sass">
.csps-container
    display: flex
    flex-direction: column
    width: 250px
    margin: 0 16px
    padding: 0 16px

.csp-item
    position: relative
    &::first-letter
        text-transform: capitalize
    &.ou
        &:before
            background-color: #F27781
    &.em
        &:before
            background-color: #B09615
    &.am
        &:before
            background-color: #04BF8A
    &.ca
        &:before
            background-color: #18298C
    &.di
        &:before
            background-color: #F29F05
    &:before
        position: absolute
        content: ""
        left: -10px
        top: 9px
        z-index: 1
        height: 5px
        width: 5px
        box-shadow: 0 0 8px rgba(0,0,0,0.5)
</style>
